<template>
  <!-- <div
    style="overflow: hidden; height: 100vh !important"
    class="justify-content-center align-items-center d-flex h-100 w-100"
    v-if="loadError">
    <div class="w-25 h-25"><img src="/assets/icon/ic_empty.svg" /></div>
  </div> -->
  <div
    id="conversation-page-v2"
    class="d-flex flex-grow-1">
    <div
      class="z2-conver-list-container"
      v-if="!app.switchCRM">
      <ConversationFilterV2
        :searchTab="searchTab"
        @updateSearchTab="updateSearchTab"
        @onSetFilter="onSetFilter"
        @onSetFilterMessage="onSetFilterMessage" />
      <!-- <div class="new-message-noti px-3 py-2">2 tin nhắn mới</div> -->
      <div
        v-if="searchTab == 'contact'"
        class="z2-conversation-list">
        <ConversationItemV2
          v-for="conversation in viewPinConversations"
          :key="conversation.id"
          :active="false"
          :accounts="accounts"
          :conversation="conversation"
          @onSelect="onSelectConversation"
          @showMenu="(e) => showMenu(e, conversation)" />
        <!-- <LoadingConversationV2
          v-if="loading"
          :num="9"></LoadingConversationV2> -->
        <div>
          <ConversationItemV2
            v-for="conversation in viewConversations"
            :key="conversation.id"
            :accounts="accounts || []"
            :conversation="conversation"
            @onSelect="onSelectConversation"
            @showMenu="(e) => showMenu(e, conversation)" />
        </div>
        <scroll-loader
          v-if="isLoadMoreReady"
          :loader-method="loadMoreConversations"
          :loader-disable="noMore"
          class="w-100">
          <LoadingConversationV2
            v-if="!noMore"
            class="w-100"
            :num="1"></LoadingConversationV2>
        </scroll-loader>
      </div>
      <div v-else>
        <div
          v-if="searchMessConversations.length"
          class="z2-conversation-list">
          <div>
            <ConversationMessageItemV2
              v-for="conversation in searchMessConversations"
              :key="conversation.lastMessageId"
              :active="false"
              :accounts="accounts"
              :conversation="conversation"
              :searchKey="filterMessage.searchKey"
              @onSelect="onSelectConversatioMessage"
              @showMenu="(e) => showMenu(e, conversation)" />
          </div>
        </div>
        <div v-else>
          <div
            v-if="!searchId"
            class="d-flex flex-column align-items-center justify-content-center"
            style="min-height: 500px">
            <img
              class="mb-2"
              src="/assets/images/empty-box.png" />
            Chưa có dữ liệu tìm kiếm
          </div>
          <div v-else>
            <LoadingConversationV2
              class="w-100 mt-0"
              :num="1"></LoadingConversationV2>
          </div>
        </div>
      </div>
    </div>
    <ConversationV2
      ref="messageV2"
      :searchKeyMessage="this.filterMessage?.searchKey || ''"
      :conversation="selectedConversation"
      @onSelect="onSelectConversation"
      @closeConversation="onCloseConversation" />
  </div>
</template>

<script>
/* eslint-disable */
import { COMMON } from "../lib/Common";
import LoadingConversationV2 from "../components/LoadingConversationV2.vue";
import ConversationItemV2 from "../components/ConversationItemV2.vue";
import ConversationMessageItemV2 from "../components/ConversationMessageItemV2.vue";
import ConversationFilterV2 from "../components/ConversationFilterV2.vue";
import ConversationV2 from "../components/ConversationV2.vue";
import { generateRandomString } from "../lib/text-utils";

export default {
  props: ['conversationId'],
  components: {
    LoadingConversationV2,
    ConversationItemV2,
    ConversationMessageItemV2,
    ConversationFilterV2,
    ConversationV2,
  },
  updated() {},
  data() {
    const PAGE_SIZE = 30;
    return {
      loadError: false,
      loading: false,
      loadingMore: false,
      isLoadMoreReady: false,
      noMore: false,
      selectAccountId: "",
      filter: {
        isGroup: null,
        unread: false,
        unReplied: null,
        searchKey: "",
        accountIds: [],
        lastMessageTime: 0,
        selectedTags: [],
        dateRange: [],
        pageSize: PAGE_SIZE,
      },
      filterMessage: {
        searchKey: "",
        isGroup: null,
        dateRange: [],
      },
      PAGE_SIZE: PAGE_SIZE,
      conversations: [],
      selectedConversation: {},
      searchMessConversations: [],
      searchId: "",
      searchTab: "contact",
    };
  },
  computed: {
    accounts() {
      return this.app.accountsZaloContact;
    },
    viewPinConversations() {
      let view = [...this.app.pinConversationView].filter((c) => !c.hidden);
      if (this.filter.isGroup !== null) {
        view = view.filter((p) => p.group == this.filter.isGroup);
      }
      if (this.filter.unread) {
        view = view.filter((p) => p.unreadCount > 0);
      }
      if (this.filter.unReplied) {
        view = view.filter((p) => p.unReplied);
      }
      if (this.filter.searchKey !== "") {
        view = view.filter(
          (p) =>
            p.toName?.toLowerCase().includes(this.filter.searchKey.toLowerCase()) ||
            (p.phone && p.phone.includes(this.subPhone(this.filter.searchKey))) ||
            (p.swName && p.swName?.toLowerCase().includes(this.filter.searchKey.toLowerCase()))
        );
      }
      if (this.filter.accountIds.length > 0) {
        view = view.filter((p) => this.checkAcc(p.accountId) == true);
      }
      if (this.filter.selectedTags.length > 0) {
        view = view.filter((p) => this.checkTags(p.tags) == true);
      }
      view.sort((a, b) => b.lastMessageTime - a.lastMessageTime);
      return view;
    },
    viewConversations() {
      let view = [...this.conversations].filter((conv) => {
        let filter = this.app.pinConversationView.filter((t) => t.id == conv.id);
        if (filter && filter.length > 0) return false;
        return true;
      });
      if (this.filter.isGroup !== null) {
        view = view.filter((p) => p.group == this.filter.isGroup);
      }
      if (this.filter.unread) {
        view = view.filter((p) => p.unreadCount > 0);
      }
      if (this.filter.unReplied) {
        view = view.filter((p) => p.unReplied);
      }
      if (this.filter.searchKey !== "") {
        view = view.filter(
          (p) =>
            p.toName?.toLowerCase().includes(this.filter.searchKey.toLowerCase()) ||
            (p.phone && p.phone.includes(this.subPhone(this.filter.searchKey))) ||
            (p.swName && p.swName?.toLowerCase().includes(this.filter.searchKey.toLowerCase()))
        );
      }
      if (this.filter.accountIds.length > 0) {
        view = view.filter((p) => this.checkAcc(p.accountId) == true);
      }
      if (this.filter.selectedTags.length > 0) {
        view = view.filter((p) => this.checkTags(p.tags) == true);
      }
      view.sort((a, b) => b.lastMessageTime - a.lastMessageTime);
      return view;
    },
    filterDepedency() {
      return [
        this.filter.isGroup,
        this.filter.unread,
        this.filter.unReplied,
        this.filter.searchKey,
        this.filter.accountIds,
        // this.filter.lastMessageTime,
        this.filter.selectedTags,
        this.filter.dateRange,
        this.filter.pageSize,
        this.filter.noTags,
      ];
    },
  },

  watch: {
    filterDepedency() {
      this.fetchConversationList();
    },
  },

  methods: {
    showMenu(e, conversation) {
      this.$refs.messageV2.showMenu(e, conversation);
    },

    getAccountList() {
      this.$http.get("/api/account").then((resp) => {
        this.accounts = resp.data;
      });
    },
    onSetFilter(filter) {
      this.filter = JSON.parse(JSON.stringify(filter));
    },
    onSetFilterMessage(filter) {
      if (!filter.searchKey) {
        this.searchMessConversations = [];
        this.searchId = "";
        return;
      }
      this.filterMessage = JSON.parse(JSON.stringify(filter));
      this.searchId = generateRandomString(6);
      let request = {
        ...this.filter,
        lastMessageTime: 0,
        pageSize: this.PAGE_SIZE,
        searchId: this.searchId,
        searchKey: this.filterMessage.searchKey,
        isGroup: this.filterMessage.isGroup,
        dateRange: this.filterMessage.dateRange,
      };
      this.loading = true;
      this.searchMessConversations = [];
      this.$http
        .post("/api/message/search", request)
        .then((resp) => {
          // this.conversations = resp.data;
          // this.noMore = true;
        })
        .finally(() => {
          this.loading = false;
          this.isLoadMoreReady = true;
        });
    },
    updateSearchTab(value) {
      this.searchTab = value;
      if (this.searchTab == "message") {
        this.onSetFilterMessage(this.filterMessage);
      } else {
        this.fetchConversationList();
      }
    },
    async fetchConversationList(loadMore = false) {
      if (!loadMore) {
        this.isLoadMoreReady = false;
      }
      this.searchId = generateRandomString(6);
      let request = {
        ...this.filter,
        lastMessageTime: loadMore ? this.filter.lastMessageTime : 0,
        pageSize: this.PAGE_SIZE,
        searchId: this.searchId,
      };
      this.loading = true;
      try {
        const resp = await this.$http.post( "/api/conversation", request);
        if (loadMore) {
          const existedIds = new Set(
            this.conversations.map(c => c.id)
          );

          const newItems = resp.data.filter(
            c => !existedIds.has(c.id)
          );

          this.conversations = this.conversations.concat(newItems);
        } else {
          this.conversations = resp.data;
        }
        this.noMore = resp.data.length < this.PAGE_SIZE || !!this.filter.searchKey;
      } catch {
      } finally {
        this.loading = false;
        this.isLoadMoreReady = true;
        this.searchId = "";
      }
    },
    loadMoreConversations() {
      if (this.conversations.length > 0) {
        this.filter.lastMessageTime = this.conversations[this.conversations.length - 1].lastMessageTime;
        this.fetchConversationList(true);
      }
    },
    checkTags(tags) {
      let rt = false;
      if (tags.length > 0) {
        tags.forEach((tag) => {
          let filter = this.filter.selectedTags.filter((t) => t == tag.id);
          if (filter && filter.length > 0) {
            rt = true;
          }
        });
      }
      return rt;
    },
    checkAcc(accountId) {
      let filter = this.filter.accountIds.filter((p) => p == accountId);
      if (filter != null && filter.length > 0) {
        return true;
      }
      return false;
    },
    onSelectConversation(conversation) {
      this.$bus.$emit("saveDraftMessage");
      if (this.selectedConversation.id && this.selectedConversation.id != conversation.id) {
        this.sendTypingSocket("stopped_typing");
      }
      this.app.selectedConversation = this.selectedConversation = conversation; // or JSON.stringify
      this.$bus.$emit("selectConversationV2", this.selectedConversation);
    },
    onCloseConversation() {
      this.app.selectedConversation = {};
      this.selectedConversation = {};
    },
    onSelectConversatioMessage(conversation) {
      conversation.isConversationMessage = true;
      this.onSelectConversation(conversation);
      this.app.selectedConversationMessage = conversation;
    },

    sendTypingSocket(type) {
      let request = {
        accountId: this.selectedConversation.accountId,
        conversationId: this.selectedConversation.id,
        type: type,
        username: this.app.user.swUsername,
      };
      this.$http.post("/api/conversation/typing", request);
    },
    updateCurrentConversation(message) {
      var date = new Date(Number(message.ts));
      var now = this.conversations.length > 0 ? new Date(this.conversations[this.conversations.length - 1].lastMessageTime) : new Date();
      const diffTime = date - now;
      const conversationId = message?.id.conversationId;

      if (diffTime >= 0) {
        var index = this.conversations.findIndex((csv) => {
          return csv.id === conversationId;
        });

        if (index >= 0 && conversationId === this.selectedConversation.id) {
          this.conversations.splice(index, 1);
          this.selectedConversation.unreadCount = 0;
          this.selectedConversation.lastContent = message.msgType == "webchat" ? message.content : null;
          this.selectedConversation.lastMessageContent = message.msgType;
          this.selectedConversation.lastMessageType = message.msgType;
          this.selectedConversation.lastMessageTime = Number(message.ts);
          this.selectedConversation.dname = message.id.uidFrom == "0" ? null : message.dname;
          this.conversations.unshift(this.selectedConversation);
          this.conversations.sort((a, b) => b.lastMessageTime - a.lastMessageTime);
        }

        // Dùng nếu ko reactive
        // this.conversations.unshift(JSON.parse(JSON.stringify(this.selectedConversation)));
        // this.conversations = [...this.conversations]
        // this.sortConversation();
      }
    },
    updateConversation(conversation) {
      const isFromFilter = conversation.source === 'filterByAccountId';
      var date = new Date(conversation.lastMessageTime);
      var now = this.conversations.length > 0 ? new Date(this.conversations[this.conversations.length - 1].lastMessageTime) : 0;
      const diffTime = date - now;
      if (diffTime >= 0 || isFromFilter) {
        var index = this.conversations.findIndex((csv) => {
          return csv.id === conversation.id;
        });

        if (conversation.id === this.selectedConversation.id) {
          conversation.unreadCount = 0;
        }

        if (index >= 0) {
          if (this.conversations[index].lastMessageTime < conversation.lastMessageTime || this.conversations[index].toName !== conversation.toName || this.conversations[index].unreadCount !== conversation.unreadCount || this.conversations[index].unReplied !== conversation.unReplied || this.conversations[index].swName !== conversation.swName) {
            this.conversations.splice(index, 1);
            this.conversations.unshift(conversation);
            this.conversations.sort((a, b) => b.lastMessageTime - a.lastMessageTime);
          }
        } else {
          this.conversations.unshift(conversation);
          this.conversations.sort((a, b) => b.lastMessageTime - a.lastMessageTime);
        }

        // this.conversations = [...this.conversations]
        // this.sortConversation();
      }
    },
    // sortConversation() {
    //   this.loading = false;
    //   this.viewConversations = [];
    //   let view = this.conversations;
    //   if (this.filter.filterGroup !== null) {

    //     view = view.filter(p => p.group == this.isGroup(this.filter.filterGroup));
    //   }
    //   if (this.filter.filterMessage === "Chưa đọc") {
    //     view = view.filter(p => p.unreadCount > 0);
    //   }
    //   if (this.filter.filterMessage === "Chưa trả lời") {
    //     view = view.filter(p => p.unReplied == true);
    //   }
    //   if (this.filter.searchKey !== "") {
    //     view = view.filter(p => p.toName.toLowerCase().includes(this.filter.searchKey.toLowerCase())
    //       || (p.phone && p.phone.includes(this.subPhone(this.filter.searchKey)))
    //       || (p.swName && p.swName.toLowerCase().includes(this.filter.searchKey.toLowerCase())));
    //   }
    //   if (this.filter.selectedAccountIds.length > 0) {
    //     view = view.filter(p => this.checkAcc(p.accountId) == true);
    //   }
    //   if (this.filter.selectedTags.length > 0) {
    //     view = view.filter(p => this.checkTags(p.tags) == true);
    //   }
    //   view.sort((a, b) => b.lastMessageTime - a.lastMessageTime);
    //   this.viewConversations = view;
    // },
    updateConversationPin(conversation) {
      var index = this.app.pinConversationView.findIndex((csv) => {
        return csv.id === conversation.id;
      });

      if (index >= 0) {
        this.app.pinConversationView.splice(index, 1);
        if (conversation.id === this.selectedConversation.id) {
          conversation.unreadCount = 0;
        }
        conversation.isPin = true;
        this.app.pinConversationView.unshift(conversation);
      }
    },
    tagConversation(data) {
      // this.conversations.forEach((conv) => {
      //   if (conv.id == data.id) {
      //     conv.tags = data.tags;
      //   }
      // });
      // this.app.pinConversationView.forEach((conv) => {
      //   if (conv.id == data.id) {
      //     conv.tags = data.tags;
      //   }
      // });

      this.conversations = this.conversations.filter((conv) => {
        if (conv.id == data.id) {
          conv.tags = data.tags;
          return data.isAssignMe;
        }
        return true;
      });

      this.app.pinConversationView = this.app.pinConversationView.filter((conv) => {
        if (conv.id == data.id) {
          conv.tags = data.tags;
          return data.isAssignMe;
        }
        return true;
      });

      if (this.selectedConversation.id == data.id && !data.isAssignMe) {
        this.app.selectedConversation = this.selectedConversation = {};
      }
    },

    typingConversation(data) {
      this.conversations.forEach((conv) => {
        if (conv.id == data.conversationId) {
          if (data.type == "typing") {
            conv.lastMessageContent = data.username + " đang soạn tin nhắn ...";
            conv.typing = true;
          } else if (data.type == "stopped_typing") {
            conv.lastMessageContent = data.lastMessageContent;
            conv.typing = false;
          }
        }
      });
    },
    typingConversationPin(data) {
      this.app.pinConversationView.forEach((conv) => {
        if (conv.id == data.conversationId) {
          if (data.type == "typing") {
            conv.lastMessageContent = data.username + " đang soạn tin nhắn ...";
            conv.typing = true;
          } else if (data.type == "stopped_typing") {
            conv.lastMessageContent = data.lastMessageContent;
            conv.typing = false;
          }
        }
      });
    },
    hiddenConversation(conversationId) {
      if (this.selectedConversation.id == conversationId) {
        this.selectedConversation = {};
      }
      var currentIndex = this.conversations.findIndex((csv) => {
        return csv.id === conversationId;
      });
      if (currentIndex >= 0) {
        this.conversations.splice(currentIndex, 1);
      }
      currentIndex = this.app.pinConversations.findIndex((csv) => {
        return csv.id === conversationId;
      });
      if (currentIndex >= 0) {
        this.app.pinConversations.splice(currentIndex, 1);
      }
      currentIndex = this.app.pinConversationView.findIndex((csv) => {
        return csv.id === conversationId;
      });
      if (currentIndex >= 0) {
        this.app.pinConversationView.splice(currentIndex, 1);
      }
    },
    readConversation(data) {
      this.conversations.forEach((conv) => {
        if (conv.id == data.id) {
          conv.unreadCount = data.unreadCount;
        }
      });
      if (this.selectedConversation.id == data.id) {
        this.selectedConversation.unreadCount = data.unreadCount;
        this.$emit("selected", this.selectedConversation);
      }
    },
    readConversationPin(data) {
      this.app.pinConversationView.forEach((conv) => {
        if (conv.id == data.id) {
          conv.unreadCount = data.unreadCount;
        }
      });
      if (this.selectedConversation.id == data.id) {
        this.selectedConversation.unreadCount = data.unreadCount;
        this.$emit("selected", this.selectedConversation);
      }
    },
    onMessageUpdate(data) {
      if (this.$refs.messageV2) {
        this.$refs.messageV2.addMessage(data);
        if (data.id.conversationId == this.selectedConversation.id) {
          this.$refs.messageV2.scrollBox(data);
          try {
            if (data.msgType === COMMON.CHAT_PHOTO || data.msgType === COMMON.CHAT_VIDEO) {
              this.$bus.$emit("updateImageOrVideoTab", data);
            } else if (data.msgType === COMMON.CHAT_FILE) {
              this.$bus.$emit("updateFileTab", data);
            } else if (data.msgType === "chat.recommended") {
              if (JSON.parse(data.content).action === "recommened.link") {
                this.$bus.$emit("updateLinkTab", data);
              }
            }
          } catch (e) {
            //
          }
        }
      }
    },
    onSearchAllMessage(data) {
      if (this.searchId === data.searchId) {
        this.searchId = "";
        this.searchMessConversations = data.data;
      }
    },
    async getDataFromContact(data) {
      const foundConversation = this.conversations.some((conversation) => {
        return conversation.id === data.conversation.id;
      });
      if (foundConversation) {
        this.onSelectConversation(data.conversation);
        return;
      } else {
        this.loadConversationById(data.conversation.id);
      }
    },
    async getConversation(id) {
      let arr = id.split("_");
      let accountId = arr[0];
      const resp = await this.$http.get("/api/conversation/getOne", {
        params: {
          conversationId: id,
          accountId: accountId,
        },
      });
      if (resp.data) {
        setTimeout(() => {
          this.onSelectConversation(resp.data);
        }, 500);
        return resp.data;
      } else {
        this.error = true;
        return null;
      }
    },
    async loadConversationById(id) {
      const conversation = await this.getConversation(id);
      if (conversation) {
        conversation.lastMessageTime = Date.now();
        this.conversations.unshift(conversation);
      }
    },
    async getPointConversations() {
      const res = await this.$http.get("/api/conversation/pointConversations");
      if (res?.data) {
        const pointData = JSON.parse(res.data).data.data || [];
        this.app.pointConversation = pointData.reduce((acc, item) => {
          acc[item.conversationId] = item;
          return acc;
        }, {});
      }
    }
  },

  mounted() {
    this.fetchConversationList();
    this.$bus.$on("data-from-contact", async (data) => {
      await this.fetchConversationList();
      this.getDataFromContact(data);
    });
    if (this.conversationId) {
      this.loadConversationById(this.conversationId);
    }
    this.getPointConversations();
  },
  beforeDestroy() {
    this.$bus.$off("conversationUpdate");
    this.$bus.$off("conversationTyping");
    this.$bus.$off("conversation_tag");
    this.$bus.$off("hidden_conversation");
    this.$bus.$off("conversationRead");
    this.$bus.$off("messageUpdate");
    this.$bus.$off("updateGrMessage");
    this.$bus.$off("tagChanged");
    this.$bus.$off("SearchMessageDto");
    this.$bus.$off("data-from-contact");
    this.$bus.$off("currentConversationUpdate");
  },
  async created() {
    this.$bus.$on("currentConversationUpdate", (data) => {
      this.updateCurrentConversation(data);
    });
    this.$bus.$on("conversationUpdate", (data) => {
      this.updateConversation(data);
      this.updateConversationPin(data);
    });
    this.$bus.$on("conversationTyping", (data) => {
      this.typingConversationPin(data);
      this.typingConversation(data);
    });
    this.$bus.$on("conversation_tag", (data) => {
      this.tagConversation(data);
    });
    this.$bus.$on("hidden_conversation", (conversationId) => {
      if (this.selectedConversation.id == conversationId) {
        this.app.selectedConversation = this.selectedConversation = {}; // or JSON.stringify
      }
      this.hiddenConversation(conversationId);
    });
    this.$bus.$on("conversationRead", (data) => {
      this.readConversationPin(data);
      this.readConversation(data);
    });
    this.$bus.$on("updateGrMessage", (data) => {
      this.onMessageUpdate(data);
    });

    this.$bus.$on("messageUpdate", (data) => {
      this.onMessageUpdate(data);
    });
    this.$bus.$on("tagChanged", (data) => {
      // this.tagChanged(data);
    });
    this.$bus.$on("SearchMessageDto", (data) => {
      this.onSearchAllMessage(data);
    });

    this.$bus.$on("updatePinConversation", (data) => {
      if (this.selectedConversation) {
        this.selectedConversation = { ...this.selectedConversation, isPin: data };
      }
    });

    if (this.app.switchCRM === true) {
      this.getConversation(this.app.conversationIdForCRM);
    }
    // this.getAccountList();
    // await this.fetchConversationList();
    this.isLoadMoreReady = true;

    window.addEventListener("click", () => {
      if (this.$refs.messageV2) {
        this.$refs.messageV2.isMenuVisible = false;
      }
    });
  },
};
</script>

<style>
.conversation-center {
  max-width: calc(100vw - 660px);
  min-width: calc(100vw - 660px);
}
</style>
